module.exports = __webpack_public_path__ + "img/retailers-2-a@2x.09246440.jpg";